import * as actionTypes from "../../actions/actionTypes";
import { setDataUniqueRowUuid } from "../layoutReducer";
import { sales, customer } from "./structure";

export const initialState = {
  connection: null,
  stagingTables: [],
  dwTables: [],
  loading: [],
  updating: false,
  creating: false,
  updateError: null,
  sample: null,
  column: {
    values: null,
  },
  structure: {
    sales, // hardcoded
    customer,
    dbName: null,
    pipeline: {},
    product: {},
  },
  sourceValues: {},
  loadingComplete: false,
  blueprints: [],
  defaultConnection: null,
  defaultDb: null,
  savingBlueprint: false,
  saveBlueprintError: null,
  isInitComplete: false,
  savingInput: false,
  deletingInput: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOAD_STAGING_TABLES_COMPLETE:
      const { dwTables, stagingTables, connection } = action;
      return { ...state, stagingTables, dwTables, connection };

    case actionTypes.GET_SAMPLE_VALUES_FROM_STAGING_START:
      return {
        ...state,
        loading: [...state.loading, actionTypes.GET_SAMPLE_VALUES_FROM_STAGING],
        sample: null,
      };

    case actionTypes.COMPLETE_WAREHOUSE_CREATE:
      return { ...state, connection: action.connection };

    case actionTypes.GET_SAMPLE_VALUES_FROM_STAGING_SUCCESS:
      return {
        ...state,
        sample: setDataUniqueRowUuid(action.results.data),
        loading: state.loading.filter(
          (l) => l !== actionTypes.GET_SAMPLE_VALUES_FROM_STAGING
        ),
      };

    case actionTypes.GET_UNIQUE_COLUMN_VALUES_FROM_STAGING_START:
      return { ...state, column: { values: null } };

    case actionTypes.GET_UNIQUE_COLUMN_VALUES_FROM_STAGING_SUCCESS:
      return { ...state, column: { values: action.results.data } };
    case actionTypes.CLEAR_SOURCE_DATA:
      return { ...state, column: { values: null }, sample: null };
    case actionTypes.POST_DATA_STRUCTURE_START: {
      return { ...state, updating: true, updateError: null };
    }
    case actionTypes.POST_DATA_STRUCTURE_SUCCESS: {
      return { ...state, updating: false };
    }
    case actionTypes.POST_DATA_STRUCTURE_FAIL: {
      return { ...state, updateError: action.error.message, updating: false };
    }

    case actionTypes.LOAD_DATA_STRUCTURE_START: {
      return { ...state, loadingComplete: false };
    }
    case actionTypes.LOAD_DATA_STRUCTURE_SUCCESS: {
      // console.log(action.results.data);
      const { product, pipeline, dbName } = action.results.data[0].settings;

      return {
        ...state,
        structure: {
          ...state.structure,
          product,
          pipeline,
          dbName,
        },
        loadingComplete: true,
      };
    }

    case actionTypes.LOAD_SEED_STAGING_DATA: {
      // This will need to be expanded to have an updatable list in the near future
      return { ...state, sourceValues: action.values };
    }

    case actionTypes.LOAD_BLUEPRINTS: {
      const { blueprints, etlBlueprints, etlChains } = action;
      return {
        ...state,
        blueprints,
        etlBlueprints,
        etlChains,
      };
    }

    case actionTypes.LOAD_TABLES_FROM_WAREHOUSE: {
      const { results, defaultConnection, defaultDb } = action;
      return { ...state, dwTables: results, defaultConnection, defaultDb };
    }

    // Initial Create
    case actionTypes.CREATE_BLUEPRINT_START: {
      return { ...state, creating: true };
    }

    case actionTypes.CREATE_BLUEPRINT_SUCCESS: {
      const { blueprints, etlBlueprints, etlChains } = action;
      return {
        ...state,
        creating: false,
        blueprints,
        etlBlueprints,
        etlChains,
      };
    }

    case "SAVE_BLUEPRINT_START":
      return {
        ...state,
        savingBlueprint: true,
        saveBlueprintError: null,
      };

    case "SAVE_BLUEPRINT_SUCCESS":
      return {
        ...state,
        savingBlueprint: false,
        // Append the created blueprint to the existing blueprints array
        blueprints: [...state.blueprints, action.payload],
      };

    case "SAVE_BLUEPRINT_FAIL":
      return {
        ...state,
        savingBlueprint: false,
        saveBlueprintError: action.error,
      };

    case actionTypes.SAVE_BLUEPRINT_INPUT_START:
      return {
        ...state,
        savingInput: true,
      };
    case actionTypes.SAVE_BLUEPRINT_INPUT_SUCCESS:
      return {
        ...state,
        etlChains: action.etlChains,
        blueprints: action.blueprints,
        savingInput: false,
      };

    case actionTypes.BLUEPRINTS_INIT_COMPLETE:
      return {
        ...state,
        isInitComplete: true,
      };

    case actionTypes.GET_UNIQUE_DATA_SUCCESS:
      const uniqueValues = action.uniqueValues.map((v) => ({
        id: v,
        label: v,
      }));
      return {
        ...state,
        uniqueValues,
        uniqueValuesTotalCount: action.totalCount,
      };

    case actionTypes.DELETE_INPUT_CHAIN_START:
      return {
        ...state,
        deletingInput: action.uuid,
      };

    case actionTypes.DELETE_INPUT_CHAIN_SUCCESS:
      return {
        ...state,
        deletingInput: false,
        etlChains: action.chains,
        blueprints: action.blueprintChains,
      };

    case actionTypes.DELETE_INPUT_CHAIN_FAIL:
      return {
        ...state,
        deletingInput: false,
      };

    default:
      return state;
  }
};

export default reducer;
